var map = {
	"./views/Commodityallocation/Commodityclass/index.vue": [
		"1687",
		"chunk-5801560a",
		"chunk-5afabe46"
	],
	"./views/Commodityallocation/brand/index.vue": [
		"686d",
		"chunk-5801560a",
		"chunk-bdff1272"
	],
	"./views/Commodityallocation/examine/index.vue": [
		"372e",
		"chunk-5801560a",
		"chunk-c6c5d540"
	],
	"./views/Commodityallocation/stock/details/index.vue": [
		"5f1f",
		"chunk-a0af202a",
		"chunk-8a02b42c"
	],
	"./views/Commodityallocation/stock/index.vue": [
		"dad4",
		"chunk-5801560a",
		"chunk-3201d8a4"
	],
	"./views/DistributionManagement/ChannelManagement/index.vue": [
		"fabd",
		"chunk-3ea9c72e"
	],
	"./views/DistributionManagement/DistributionMerchantManagement/index.vue": [
		"f61e",
		"chunk-05787fa5"
	],
	"./views/DistributionManagement/DistributionOrders/index.vue": [
		"2e9b",
		"chunk-7bc2d22c"
	],
	"./views/Merchantmanagement/Businesslistings/index.vue": [
		"8015",
		"chunk-5801560a",
		"chunk-0cf34570"
	],
	"./views/Merchantmanagement/Expiration/index.vue": [
		"05f1",
		"chunk-5801560a",
		"chunk-640dee85"
	],
	"./views/Merchantmanagement/Newmerchants/index.vue": [
		"4f18",
		"chunk-aa093e84"
	],
	"./views/Merchantmanagement/Parameterconfiguration/index.vue": [
		"6dac",
		"chunk-a0af202a",
		"chunk-8eb5c210"
	],
	"./views/Merchantmanagement/Paymentrecord/index.vue": [
		"1a7c",
		"chunk-5801560a",
		"chunk-62ddfcfe"
	],
	"./views/Merchantmenu/Menuconfiguration/index.vue": [
		"81a1",
		"chunk-3cb1fdcb"
	],
	"./views/Merchantmenu/md/mdthree/index.vue": [
		"2e38",
		"chunk-040e9f71"
	],
	"./views/Merchantmenu/md/mdtow/index.vue": [
		"b02f",
		"chunk-3aab0037"
	],
	"./views/Merchantmenu/zht/zhtthree/index.vue": [
		"7009",
		"chunk-b9fd6c2a"
	],
	"./views/Merchantmenu/zht/zhttow/index.vue": [
		"11d4",
		"chunk-b305a560"
	],
	"./views/Paymentanagement/Settings/index.vue": [
		"0be2",
		"chunk-41f268ad"
	],
	"./views/Staffmanagement/Employee/index.vue": [
		"5953",
		"chunk-75cba6ab"
	],
	"./views/Staffmanagement/Role/Addemployee/index.vue": [
		"9fb4",
		"chunk-fc00b1bc"
	],
	"./views/Staffmanagement/Role/addrole/index.vue": [
		"e8fb",
		"chunk-f355e620"
	],
	"./views/Staffmanagement/Role/index.vue": [
		"1b90",
		"chunk-4158e6fd"
	],
	"./views/auth/login/index.vue": [
		"a135",
		"chunk-5fcc547e"
	],
	"./views/home/index.vue": [
		"7abe",
		"chunk-2d0e19c3"
	],
	"./views/layout/index.vue": [
		"162e"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "6158";
module.exports = webpackAsyncContext;